import React, { useState } from 'react';

const RegisterOperator = () => {
  const [form, setForm] = useState({
    nomeImpresa: '',
    ragioneSociale: '',
    partitaIVA: '',
    email: '',
    password: '',
    repeatPassword: '',
    regione: '',
    provincia: '',
    citta: '',
    indirizzo: '',
    nazionalita: '',
    settore: '',
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Submitted:', form);
  };

  return (
    <div className="min-h-screen flex">
      {/* Left panel */}
      <div className="w-1/2 bg-gradient-to-r from-blue-400 to-purple-500 text-white flex flex-col justify-center items-center p-10">
        <div className="text-center">
          <div className="text-5xl mb-4">👻</div>
          <h1 className="text-3xl font-bold mb-2">Romanchat</h1>
          <p className="text-sm max-w-md">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.
          </p>
          <button className="mt-6 px-6 py-2 rounded-full bg-gradient-to-r from-purple-400 to-blue-400 hover:scale-105 transition">
            GET STARTED
          </button>
        </div>
      </div>

      {/* Right panel */}
      <div className="w-1/2 bg-white flex justify-center items-center">
        <form onSubmit={handleSubmit} className="w-full max-w-md p-10 rounded-xl shadow-xl">
          <h2 className="text-2xl font-semibold text-purple-600 mb-6 text-center">Register</h2>

          <div className="grid grid-cols-1 gap-4">
            <input name="nomeImpresa" placeholder="Nome Impresa*" onChange={handleChange} value={form.nomeImpresa} className="input" required />
            <input name="ragioneSociale" placeholder="Ragione Sociale*" onChange={handleChange} value={form.ragioneSociale} className="input" required />
            <input name="partitaIVA" placeholder="Partita IVA/CF*" onChange={handleChange} value={form.partitaIVA} className="input" required />
            <input type="email" name="email" placeholder="Email" onChange={handleChange} value={form.email} className="input" required />
            <input type="password" name="password" placeholder="Password" onChange={handleChange} value={form.password} className="input" required />
            <input type="password" name="repeatPassword" placeholder="Repeat Password" onChange={handleChange} value={form.repeatPassword} className="input" required />
            <input name="regione" placeholder="Regione" onChange={handleChange} value={form.regione} className="input" />
            <input name="provincia" placeholder="Provincia" onChange={handleChange} value={form.provincia} className="input" />
            <input name="citta" placeholder="Città" onChange={handleChange} value={form.citta} className="input" />
            <input name="indirizzo" placeholder="Indirizzo" onChange={handleChange} value={form.indirizzo} className="input" />
            <input name="nazionalita" placeholder="Nazionalità" onChange={handleChange} value={form.nazionalita} className="input" />
            <input name="settore" placeholder="Settore" onChange={handleChange} value={form.settore} className="input" />
          </div>

          <div className="flex items-center mt-4">
            <input type="checkbox" required className="mr-2" />
            <span className="text-sm">I accept the <a href="#" className="text-blue-500">Terms of Use</a> and <a href="#" className="text-blue-500">Privacy Policy</a></span>
          </div>

          <button type="submit" className="w-full mt-6 bg-gradient-to-r from-purple-500 to-blue-500 text-white py-2 rounded-full hover:scale-105 transition">
            Sign Up
          </button>

          <p className="text-sm text-center mt-4">
            Already a member? <a href="#" className="text-blue-500">Sign in</a>
          </p>

          <div className="flex justify-center space-x-2 mt-4">
            <span className="w-3 h-3 bg-blue-300 rounded-full"></span>
            <span className="w-3 h-3 bg-blue-500 rounded-full"></span>
            <span className="w-3 h-3 bg-blue-300 rounded-full"></span>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegisterOperator;
